import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import axios from 'libs/fetch'
import { apiRoutes } from 'config/apiRoutes'
import { useToast } from 'shared/hooks'
import { queryKeys } from 'config/queryKeys'

type UseForceCompleteProps = {
	id: number | undefined
	closeModal: () => void
}

export const useForceComplete = ({ id, closeModal }: UseForceCompleteProps) => {
	const queryClient = useQueryClient()
	const { t } = useTranslation()

	const { mutate: forceComplete } = useMutation({
		mutationFn: (id: number) => axios.post(apiRoutes.bookingForceComplete(id.toString())),
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Booking marked as completed')
			})()

			if (id) {
				queryClient.invalidateQueries({ queryKey: queryKeys.bookings.detail(id.toString()) })
			}
			closeModal()
		},
		onError: (err: any) => {
			useToast({
				type: 'error',
				message: err.response?.data?.detail ?? t('Something went wrong')
			})()
		}
	})

	return {
		forceComplete
	}
}
